import { TModulo } from "../../Interfaces/Utils/Modulo/ModuloInterfaces";
import { ACESSOS } from "../../Routes/Acessos";

interface IModuloInfo {
    color: string;
    id?: number;
    DS_LINK_TELA_ATENDIMENTO?: (IDCaso: number) => string;
    DS_LINK_TELA_CLIENTE?: (IDCliente: number) => string;
    DS_URL_GESTAO_CLIENTES?: string;
    DS_URL_GESTAO_ATENDIMENTO?: string;
    DS_NOME: string;
}

export const MODULOS: Record<TModulo, IModuloInfo> & {
    ID(id: number): IModuloInfo;
} = {
    Geral: {
        color: "--capys",
        DS_URL_GESTAO_CLIENTES: ACESSOS.GERAL.TELAS.GESTAO_CLIENTES.DS_PATH,
        DS_NOME: "Geral",
    },
    Atendimento: {
        color: "--AtendimentoCliente",
        id: ACESSOS.ATENDIMENTO.ID_MODULO,
        DS_URL_GESTAO_ATENDIMENTO:
            ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS
                .DS_PATH,
        DS_URL_GESTAO_CLIENTES:
            ACESSOS.ATENDIMENTO.TELAS.GESTAO_CLIENTES.DS_PATH,
        DS_LINK_TELA_CLIENTE: ACESSOS.ATENDIMENTO.TELAS.CLIENTE.DS_LINK,
        DS_LINK_TELA_ATENDIMENTO: ACESSOS.ATENDIMENTO.TELAS.ATENDIMENTO.DS_LINK,
        DS_NOME: "Atendimento ao Cliente",
    },
    Cobranca: {
        color: "--Cobranca",
        id: ACESSOS.COBRANCA.ID_MODULO,
        DS_URL_GESTAO_ATENDIMENTO:
            ACESSOS.COBRANCA.TELAS.GESTAO_ATENDIMENTOS.DS_PATH,
        DS_URL_GESTAO_CLIENTES: ACESSOS.COBRANCA.TELAS.GESTAO_CLIENTES.DS_PATH,
        DS_LINK_TELA_ATENDIMENTO: ACESSOS.COBRANCA.TELAS.ATENDIMENTO.DS_LINK,
        DS_LINK_TELA_CLIENTE: ACESSOS.COBRANCA.TELAS.CLIENTE.DS_LINK,
        DS_NOME: "Cobrança",
    },
    Assistencia: {
        color: "--AssistenciaTecnica",
        id: ACESSOS.ASSISTENCIA.ID_MODULO,
        DS_LINK_TELA_ATENDIMENTO: ACESSOS.ASSISTENCIA.TELAS.ATENDIMENTO.DS_LINK,
        DS_URL_GESTAO_CLIENTES:
            ACESSOS.ASSISTENCIA.TELAS.GESTAO_CLIENTES.DS_PATH,
        DS_NOME: "Assistência Técnica",
    },
    HelpDesk: {
        color: "--HelpDesk",
        id: ACESSOS.HELPDESK.ID_MODULO,
        DS_NOME: "Atendimento Whatsapp",
    },
    PortalAdmin: {
        color: "--PosOcupacional",
        id: ACESSOS.PORTAL_ADMIN.ID_MODULO,
        DS_NOME: "Pós Ocupacional",
    },
    Repasse: {
        color: "--Repasse",
        id: ACESSOS.REPASSE.ID_MODULO,
        DS_NOME: "Repasse",
    },
    EntregaChaves: {
        color: "--EntregaChaves",
        id: ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO,
        DS_NOME: "Vistoria e Entrega de Chaves",
    },
    PosOcupacional: {
        color: "--PosOcupacional",
        id: ACESSOS.PORTAL_ADMIN.ID_MODULO,
        DS_NOME: "Pós Ocupacional",
    },
    Vendas: {
        color: "--Vendas",
        id: ACESSOS.VENDAS.ID_MODULO,
        DS_NOME: "Vendas",
    },
    Automacao: {
        color: "--Automacao",
        id: ACESSOS.AUTOMACAO.ID_MODULO,
        DS_NOME: "Automacao",
    },
    ID(id) {
        const modulo = Object.values(this).find((v) => {
            const modulo = v as IModuloInfo;
            return modulo.id === id;
        });
        if (!modulo) return this.Geral;
        else return modulo as IModuloInfo;
    },
};
